import type { CasesStoreState } from "@/Pages/Cases/CasesStoreState";
import type { Filter } from "@/Pages/Cases/filtering/filters/CaseFilter";
import { addFilter, addFilters } from "@/Pages/Cases/filtering/FilterManager";
import { dashboardFiltersToFilters } from "@/Pages/Cases/filtering/filters/dashboardFiltersToFilters";
import { modeToFilters } from "@/Pages/Cases/filtering/filters/modeToFilters";
import { CaseMode } from "@/App/types/CaseMode";
import { createFilterSetForDay } from "@/Pages/Cases/filtering/filters/filterForDay";
import { casesViewToFilter } from "@/Pages/Cases/filtering/filters/casesViewToFilter";

export const getMainFilters = (state: CasesStoreState): Filter[] => {
  let filters = [
    ...addFilters({ filters: [], filtersToAdd: dashboardFiltersToFilters(state.filters) }),
    ...addFilter({ filters: [], filterToAdd: modeToFilters(state.mode) }),
  ];
  const { showCasesForDay } = state;
  switch (state.mode) {
    case CaseMode.ift:
      if (showCasesForDay) {
        filters = addFilter({
          filters,
          filterToAdd: createFilterSetForDay(showCasesForDay, [
            { fieldName: "ift.expectedPickupTime", skipIfNoValue: true, primary: true },
            { fieldName: "createdAt" },
          ]),
        });
      }
      break;
    case CaseMode.mih:
      if (showCasesForDay) {
        filters = addFilter({
          filters,
          filterToAdd: createFilterSetForDay(showCasesForDay, [
            { fieldName: "mih.appointmentTime", skipIfNoValue: true, primary: true },
            { fieldName: "createdAt" },
          ]),
        });
      }
      break;
    default:
      filters = addFilter({ filters, filterToAdd: casesViewToFilter(state.casesView) });
      break;
  }

  return filters;
};
